import React from 'react';
import { BRAND, isMarketGB } from '../../../../constants/main';
import { StockModelCardDealerInfoStyledAC } from './AC/StockModelCardDealerInfoStyled.AC';
import { StockModelCardDealerInfoStyledOV } from './OV/StockModelCardDealerInfoStyled.OV';
import { StockModelCardDealerInfoStyledOVGB } from './OV/StockModelCardDealerInfoStyled.OVGB';
import { StockModelCardDealerInfoStyledAP } from './AP/StockModelCardDealerInfoStyled.AP';
import { StockModelCardDealerInfoStyledDS } from './DS/StockModelCardDealerInfoStyled.DS';
import { StockModelCardDealerInfoStyled } from './StockModelCardDealerInfoStyled';
import { SC } from '../../../../styles/theme';
import { TBudgetType } from '../../../../services/core/sdk/constants/sdkFields';
import { BrandTypes } from '../../../../types/brands';
import { IMonthlyPrice } from '../../../../services/stock/models/stockItem.price.model';

export type StockModelCardDealerInfoProps = SC & {
    paymentJourney: TBudgetType;
    availabilityDate?: string;
    dealerName: string;
    dealerLocationHeight: number | string
    dealerCity: string;
    dealerDistance?: number;
    id?: number | string;
    basePrice: number;
    monthlyPrice: number;
    monthlyDeposit: number;

    handleRedirect: () => void;
    isSubmitting?: boolean;

    processCalculateSummaryData: () => void;
};

const StockModelCardDealerInfo = (props: StockModelCardDealerInfoProps) => {
    if (BRAND === BrandTypes.AC) return <StockModelCardDealerInfoStyledAC {...props} />;
    if (BRAND === BrandTypes.AP) return <StockModelCardDealerInfoStyledAP {...props} />;
    if (BRAND === BrandTypes.DS) return <StockModelCardDealerInfoStyledDS {...props} />;
    if (BRAND === BrandTypes.OV)
        return isMarketGB ? (
            <StockModelCardDealerInfoStyledOVGB {...props} />
        ) : (
            <StockModelCardDealerInfoStyledOV {...props} />
        );
    return <StockModelCardDealerInfoStyled {...props} />;
};

export default StockModelCardDealerInfo;
